module.exports = function getResource(label, vars = []) {
    let resources = {
        mostMention: 'Les plus mentionnés'
    };
    return resources[label];
};
